




























































































import Vue from "vue";
import Component from "vue-class-component";
import { LoadingSpinnerService } from "@/store";
import { BvModalEvent } from "bootstrap-vue";
import { LoadingState } from "../../store/services/loadingspinner.store";

@Component({
  name: "loading-spinner"
})
export default class LoadingSpinner extends Vue {
  get Visible(): boolean {
    return LoadingSpinnerService.Visible;
  }

  set Visible(val: boolean) {
    // Setter required for modal v-model property
  }

  get Message(): string {
    return LoadingSpinnerService.Message;
  }

  get State(): LoadingState {
    return LoadingSpinnerService.State;
  }

  get workingState(): boolean {
    return this.State == LoadingState.working;
  }

  get successState(): boolean {
    return this.State == LoadingState.success;
  }

  get failureState(): boolean {
    return this.State == LoadingState.failure;
  }

  prevent(evt: BvModalEvent) {
    if (this.Visible && !this.failureState) {
      evt.preventDefault();
    } else {
      LoadingSpinnerService.Hide();
    }
  }
}
